module.exports = __webpack_public_path__ + "img/AufDenKlippen.e5df17aa.svg";